(() => {
 const initialise = () => document.querySelectorAll('.crowe-lp').forEach(root => {
  if(root.dataset.croweInitialised) return;
  root.dataset.croweInitialised = 'true';
  // Qikify mounts asynchronously. Scope the display heading to this campaign form.
  const formSlot = root.querySelector('[data-crowe-form-slot]');
  if (formSlot) {
   const updateHeading = () => {
    const heading = formSlot.querySelector('#bcontact-form-title-550592');
    if (heading && heading.textContent.trim() === 'Create Your Own Form') {
     heading.textContent = 'Request a gifting proposal';
    }
   };
   updateHeading();
   new MutationObserver(updateHeading).observe(formSlot, {childList:true, subtree:true, characterData:true});
  }

  // Hide floating proposal prompts whenever the proposal section is visible.
  const proposalSection = root.querySelector('#crowe-lp-proposal');
  if (proposalSection) {
   const updateSticky = () => {
    const bounds = proposalSection.getBoundingClientRect();
    root.classList.toggle('crowe-lp-form-in-view', bounds.bottom > 0 && bounds.top < window.innerHeight);
   };
   updateSticky();
   new IntersectionObserver(updateSticky, {threshold:0}).observe(proposalSection);
   window.addEventListener('resize', updateSticky, {passive:true});
  }

  const activate = tab => {
   root.querySelectorAll('[role="tab"]').forEach(t => { const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1; });
   root.querySelectorAll('[role="tabpanel"]').forEach(p => {p.hidden=p.id!==tab.getAttribute('aria-controls');});
  };
  root.querySelectorAll('[role="tab"]').forEach(t=>{t.tabIndex=t.getAttribute('aria-selected')==='true'?0:-1;});
  root.addEventListener('click',event => {
   const tab=event.target.closest('[role="tab"]');if(tab && root.contains(tab)){activate(tab);return;}
   const cta=event.target.closest('[data-crowe-proposal]');if(!cta || !root.contains(cta))return;
   const form=root.querySelector('[data-crowe-form-slot]');
   if(form){form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}
  });
  root.addEventListener('keydown',event=>{
   const tab=event.target.closest('[role="tab"]');if(!tab)return;
   const tabs=Array.from(root.querySelectorAll('[role="tab"]'));let n=tabs.indexOf(tab);
   if(event.key==='ArrowRight')n=(n+1)%tabs.length;else if(event.key==='ArrowLeft')n=(n+tabs.length-1)%tabs.length;else if(event.key==='Home')n=0;else if(event.key==='End')n=tabs.length-1;else return;
   event.preventDefault();activate(tabs[n]);tabs[n].focus();
  });
 });
 initialise();document.addEventListener('shopify:section:load',initialise);
})();
